import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { filterSelector } from "app/selectors";
import { useParams } from "react-router-dom";
import MainHeader from "pages/main/components/MainHeader/MainHeader";
import MainStyled from "./MainStyled";
import Rooms from "components/rooms/Rooms";
import { handleError, request } from "app/api";
import { get } from "lodash";
import moment from "moment";

const Main = () => {
    const { hotelId, lan = "en", targetCategoryId } = useParams();
    const filterData = useSelector(filterSelector);
    const [loading, setLoading] = useState(false);
    const [{ categories, rates, howManyDays }, setState] = useState({});

    const getAllCategories = () => {
        setLoading(true);
        const rooms = get(filterData, "nomers", []).map((item) => ({
            capacity: item.people + item.children,
        }));
        const { startDate, endDate } = get(filterData, "dateRange", {});
        const howManyDays = moment(endDate).diff(moment(startDate), "days");
        setState((s) => ({ ...s, howManyDays }));

        // GET RATES
        request({
            url: `rate/get-all-open/${hotelId}${
                targetCategoryId ? `/${targetCategoryId}` : ""
            }/${lan}/${get(filterData, "dateRange.startDate")}/${get(
                filterData,
                "dateRange.endDate"
            )}`,
            method: "get",
            success: ({ data: rates }) => {
                let allrates = [];
                rates.forEach((rate, i) => {
                    if (!rate) return;
                    const { id: rateId, rateDiscounts = [], autoCancelHours } = rate;
                    const tempRates = rateDiscounts.map((discount) => ({
                        ...discount,
                        rateId,
                        autoCancelHours,
                        isDiscount: true,
                    }));

                    const hasCompatableDiscountRate = tempRates.some(
                        (rate) => rate.minimalStayDays <= howManyDays
                    );

                    if (!hasCompatableDiscountRate || rate.minimalStayDays === howManyDays)
                        tempRates.unshift({ ...rate, rateId });
                    allrates = allrates.concat(tempRates);
                });
                setState((s) => ({ ...s, rates: allrates, howManyDays }));
            },
            fail: handleError,
        });

        // GET CATEGORIES
        request({
            url: `category/get-all-category${targetCategoryId ? "-v2/" + targetCategoryId : ""}`,
            method: "put",
            attributes: {
                rooms,
                capacity: filterData.peopleCount + filterData.childrenCount,
                hotelId,
                langCode: lan,
                fromDate: moment(filterData.dateRange?.startDate).format("YYYY-MM-DD"),
                toDate: moment(filterData.dateRange?.endDate).format("YYYY-MM-DD"),
                ...filterData.dateRange,
            },
            success: ({ data }) => {
                setState((s) => ({ ...s, categories: data }));
                setLoading(false);
            },
            fail: (e) => {
                setLoading(false);
                handleError(e);
            },
        });
    };

    // useEffect(() => {
    //     if (
    //         filterData.peopleCount + filterData.childrenCount > 0 &&
    //         get(filterData, "dateRange.startDate") &&
    //         get(filterData, "dateRange.endDate")
    //     ) {
    //         getAllCategories();
    //     }
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, []);

    return (
        <MainStyled>
            <MainHeader getAllCategories={getAllCategories} loading={loading} />
            <Rooms
                {...{
                    categories,
                    targetCategoryId,
                    rates,
                    howManyDays,
                }}
            />
        </MainStyled>
    );
};

export default Main;
